import type { ActivitySuggestionsSearchCriteria } from '@libs/trip-planner-interfaces';
import { GraphQL } from '@libs/trip-planner-interfaces';
import { normalizeDateOnlyString } from '@libs/utils';

import { getRecipeQL } from './recipeQL';

export function getSuggestedAvailabilityRequestQL(
  criteria: ActivitySuggestionsSearchCriteria
): GraphQL.GetSuggestedAvailabilityRequestQL {
  return {
    recipe: getRecipeQL({
      userCriteria: criteria.userCriteria.recipe,
      businessCriteria: criteria.businessCriteria,
    }),
    ingredientIndex: criteria.userCriteria.ingredientIndex,
    constraint: criteria.userCriteria.constraint,
    day: normalizeDateOnlyString(criteria.userCriteria.day),
    suggestedBy: GraphQL.InputAvailibityOrderQL.Popular,
    numberOfSuggestions: 5,
  };
}
